import styled from 'styled-components';

export const Sections = styled.div`
  @media (max-width: 768px) {
    //overflow: scroll;
    margin: 0 18px;

    scroll-behavior: smooth;
    &::-webkit-scrollbar {
      display: none;
    }
  }
`;

export const Section = styled.div`
  position: relative;
  z-index: 0;
  --per-row: 3;
  display: grid;
  grid-template-columns: repeat(var(--per-row), minmax(0, 1fr));
  grid-auto-flow: dense;
  gap: 8px;
  margin-bottom: 8px;

  @media (max-width: 758px) {
    position: static;
    gap: 14px;
    
  }

  ${({ $hasScroll }) =>
    $hasScroll &&
    `
    @media (max-width: 768px) {
    display: flex;
    overflow-x: scroll;
    //  flex-wrap: nowrap; 
    // overflow: hidden;
    // overflow-x: scroll;
    scroll-behavior: smooth;
 
    &::-webkit-scrollbar {
  display: none;
  }
  }
  `}

  @media (min-width: 800px) {
    --per-row: 5;
    gap: 12px;
  }

  @media (min-width: 900px) {
    --per-row: 6;
    gap: 12px;
  }

  @media (min-width: 1000px) {
    --per-row: 6;
    gap: 24px;
  }
`;
export const SubSection = styled(Section)`
  @media (max-width: 768px) {
    overflow-x: unset;
  }
`;

export const SectionBlocks = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 24px;
  margin-top: 32px;

  @media (max-width: 768px) {
    //margin-right: 16px;
    margin-top: 16px;
    margin-right: 18px;
  }
`;

export const SectionBlock = styled.div``;

export const SectionViewAll = styled.a`
  display: flex;
  background: linear-gradient(90deg, #ff9500 0%, #ff5e00 100%);
  height: 40px;
  align-items: center;
  padding: 0 24px;
  border-radius: 8px;
  cursor: pointer;
  color: #fff;
  text-align: center;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 22.4px */
  &:after {
    content: '${(props) => props.$count}';
    color: #fff674;
    margin-left: 8px;
  }
  @media (max-width: 768px) {
    height: 28px;
    padding: 0 8px;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 130%; /* 15.6px */
  }
  &:hover {
    opacity: 0.9;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;
  flex: 0 0 auto;
  scroll-snap-align: center;
`;
